import { Injectable } from '@angular/core';
import {Milestone} from "../interfaces/milestone";

@Injectable({
  providedIn: 'root'
})
export class MilestonesService {

  private _milestones: Milestone[] = [
    {id: 0, name: "Opal", iconName: "Opal.png", sequenceFolder: "Opal", points: 500, hasAnimation: true},
    {id: 1, name: "Amber", iconName: "Amber.png", sequenceFolder: "Amber", points: 1500, hasAnimation: true},
    {id: 2, name: "Ruby", iconName: "Rhubi.png", sequenceFolder: "Rhubi", points: 3000, hasAnimation: true},
    {id: 3, name: "Rhodonite", iconName: "Rhodonite.png", sequenceFolder: "Rhodonite", points: 5000, hasAnimation: true},
    {id: 4, name: "Sapphire", iconName: "Sapphire.png", sequenceFolder: "Sapphire", points: 8000, hasAnimation: true},
    {id: 5, name: "Lapis lazuli", iconName: "Lapis_lazuli.png", sequenceFolder: "Lapis_lazuli", points: 12000, hasAnimation: true},
    {id: 6, name: "Quartz", iconName: "Quartz.png", sequenceFolder: "Quartz", points: 17000, hasAnimation: true},
    {id: 7, name: "Carnelian", iconName: "Carnelian.png", sequenceFolder: "Carnelian", points: 29000, hasAnimation: true},
    {id: 8, name: "Topaz", iconName: "Topaz.png", sequenceFolder: "Topaz", points: 51000, hasAnimation: true},
    {id: 9, name: "Amethyst", iconName: "Amethyst.png", sequenceFolder: "Amethyst", points: 83000, hasAnimation: true},
    {id: 10, name: "Emerald", iconName: "Emerald.png", sequenceFolder: "Emerald", points: 120000, hasAnimation: true},
    {id: 11, name: "Diamond", iconName: "Diamond.png", sequenceFolder: "Diamond", points: 200000, hasAnimation: true},
  ];

  readonly MAX_EXPERIENCE_VALUE = 5000000;

  constructor() { }

  getMilestones(): Milestone[] {
    return this._milestones;
  }
}
